var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRaDetailedConsultation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3201 21.74C18.1201 21.72 17.8801 21.72 17.6601 21.74C12.9001 21.58 9.12012 17.68 9.12012 12.88C9.12012 7.98 13.0801 4 18.0001 4C22.9001 4 26.8801 7.98 26.8801 12.88C26.8601 17.68 23.0801 21.58 18.3201 21.74Z",
    stroke: "#6C6C6C",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8201 8C36.7001 8 39.8201 11.14 39.8201 15C39.8201 18.78 36.8201 21.86 33.0801 22C32.9201 21.98 32.7401 21.98 32.5601 22",
    stroke: "#6C6C6C",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.31994 29.12C3.47994 32.36 3.47994 37.64 8.31994 40.86C13.8199 44.54 22.8399 44.54 28.3399 40.86C33.1799 37.62 33.1799 32.34 28.3399 29.12C22.8599 25.46 13.8399 25.46 8.31994 29.12Z",
    stroke: "#DD706C",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6799 40C38.1199 39.7 39.4799 39.12 40.5999 38.26C43.7199 35.92 43.7199 32.06 40.5999 29.72C39.4999 28.88 38.1599 28.32 36.7399 28",
    stroke: "#DD706C",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRaDetailedConsultation);
export default __webpack_public_path__ + "static/media/ra-DetailedConsultation.f08457bc8226d0922fbf42a179e0445e.svg";
export { ForwardRef as ReactComponent };